(() => {
  const heads = document.querySelectorAll(".accordion__head");

  heads.forEach((head) => {
    head.addEventListener("click", () => {
      const accordionItem = head.parentElement;
      const content = accordionItem.querySelector(".accordion__content");
      if (accordionItem.classList.contains("isOpen")) {
        content.style.maxHeight = `0`;
        accordionItem.classList.remove("isOpen");
      } else {
        content.style.maxHeight = `${content.scrollHeight}px`;
        accordionItem.classList.add("isOpen");
        const eventOpen = new CustomEvent("openAccordionItem", {
          bubbles: true,
          detail: accordionItem,
        });
        accordionItem.dispatchEvent(eventOpen);
      }

      if (
        head.getAttribute("data-scroll-me") === "yes" &&
        window.matchMedia("(max-width: 600px)").matches
      ) {
        const eventFuncScroll = new CustomEvent("functionalScroll", {
          bubbles: true,
          detail: 600,
        });
        window.dispatchEvent(eventFuncScroll);
        setTimeout(() => {
          head.scrollIntoView({ behavior: "smooth" });
        }, 300);
      }
    });
  });

  const accordions = document.querySelectorAll(".accordion");

  accordions.forEach((accordion) => {
    accordion.addEventListener("openAccordionItem", (e) => {
      [...accordion.children].forEach((child) => {
        if (!child.isEqualNode(e.detail)) {
          if (child.classList.contains("isOpen")) {
            child.querySelector(".accordion__head").click();
          }
        }
      });
    });
  });

  heads.forEach((head) => {
    const accordionItem = head.parentElement;
    const content = accordionItem.querySelector(".accordion__content");
    if (accordionItem.classList.contains("isOpen")) {
      content.style.maxHeight = `${content.scrollHeight}px`;
    }
  });
})();
